// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__GHV1T","content":"LayoutSettings_content__2LEcX"};